<template>
  <div
    class="b-tooltip"
    :class="[type, position, size, {'is-dashed': dashed}]"
  >
    <transition name="fade">
      <div
        v-show="isActive"
        class="tooltip-content"
      >
        {{ label }}
      </div>
    </transition>
    <div
      class="tooltip-trigger"
      @mouseenter="open"
      @mouseleave="close"
    >
      <slot/>
    </div>
  </div>
</template>

<script setup lang="ts">
  import {onUnmounted, ref} from 'vue';

  /** Hover tooltip, styled by assets/styles/components/_tooltip.scss (the Buefy 0.9 tooltip styles). */
  const props = withDefaults(defineProps<{
    label: string;
    position?: 'is-top' | 'is-bottom' | 'is-left' | 'is-right';
    type?: string;
    size?: string;
    dashed?: boolean;
    /** Milliseconds the pointer has to rest on the trigger before the tooltip shows. */
    delay?: number;
  }>(), {
    position: 'is-top',
    type: 'is-primary',
    size: 'is-medium',
    dashed: false,
    delay: 0,
  });

  const isActive = ref(false);
  let timer: ReturnType<typeof setTimeout> | undefined;

  function open(): void {
    if (!props.delay) {
      isActive.value = true;
      return;
    }
    timer = setTimeout(() => {
      isActive.value = true;
      timer = undefined;
    }, props.delay);
  }

  function close(): void {
    if (timer) {
      clearTimeout(timer);
      timer = undefined;
    }
    isActive.value = false;
  }

  onUnmounted(close);
</script>
